import React, { useEffect, useMemo, useState } from 'react';
import { Tabs, Tooltip } from 'antd';

/**
 * 屬性抽屜內的「右側垂直 icon-only 分頁」。
 *
 * sections: [{ key, icon, tooltip, children, hidden? }]
 * - 只顯示 icon，名稱用 tooltip 呈現。
 * - 自動過濾 hidden=true 的分頁。
 * - 切換節點時會重置到第一個可見分頁。
 */
const PropertySectionTabs = ({
  sections = [],
  resetKey,
  defaultActiveKey,
  className = '',
  size = 'small',
}) => {
  const visibleSections = useMemo(
    () => (sections || []).filter((s) => s && !s.hidden),
    [sections]
  );

  const fallbackKey = visibleSections[0]?.key;
  const [activeKey, setActiveKey] = useState(defaultActiveKey || fallbackKey);

  useEffect(() => {
    if (!visibleSections.length) return;
    const exists = visibleSections.some((s) => s.key === activeKey);
    if (!exists) {
      setActiveKey(defaultActiveKey || visibleSections[0].key);
    }
  }, [visibleSections, activeKey, defaultActiveKey]);

  useEffect(() => {
    if (!visibleSections.length) return;
    setActiveKey(defaultActiveKey || visibleSections[0].key);
  }, [resetKey]);

  if (!visibleSections.length) return null;

  const items = visibleSections.map((s) => ({
    key: s.key,
    label: (
      <Tooltip placement="left" title={s.tooltip || s.key}>
        <span className="wfd-section-tab-icon" aria-label={s.tooltip || s.key}>
          {s.icon}
        </span>
      </Tooltip>
    ),
    children: <div className="wfd-section-tab-content">{s.children}</div>,
  }));

  return (
    <Tabs
      tabPosition="right"
      activeKey={activeKey}
      onChange={setActiveKey}
      items={items}
      size={size}
      className={`wfd-property-section-tabs ${className}`.trim()}
      destroyInactiveTabPane={false}
    />
  );
};

export default PropertySectionTabs;
